export default {
  GAME: 'SPIEL',
  Winner: 'Gewinner',
  Win: 'Gewinn',
  Chance: 'Chance',
  'Chance to win': 'Chance to win',
  'At stake': 'Alle Wetteinsätze',
  'Sign in through STEAM to participate': 'Bei STEAM anmelden um teilzunehmen',
  'Steam trade link': 'Steamlink für den Handel',
  'Your chance': 'Your chance',
  'Be first to deposit': 'Setzen Sie als Erster',
  'Place a bet': 'Wetteinsatz',
  'Deposit more': 'Mehr setzen',
  'Min bet': 'Min. Einsatz',
  'Max bet': 'Max. Wette',
  'Bet amount': 'Höhe des Wetteinsatzes',
  'max. items': 'Max. Items',
  Tickets: 'Tickets',
  from: 'from',
  to: 'to',
  'Tickets to from': 'Tickets: von #{{ from  }} bis #{{ to }}',
  Skins: 'Skins',
  Coins: 'Punkte',
  'VIRTUAL SKINS': 'virtuelle Skins',
  'Round number': 'Rundennummer',
  'Winning after commission': 'Gewinn nach Provision',
  Loading: 'Laden',
};
